<template>
  <v-dialog
    v-model="dialog"
    width="400px">
    <div class="dialog-container">
      <h3>{{ editPayment? 'Edit': 'Add' }} Payment Record</h3>

      <el-form
        ref="form"
        :model="formData"
        :rules="rules"
        class="demo-ruleForm">
        <!-- <div class="form-item">
          <span>Action</span>
          <v-select
            v-model="formData.action"
            :list="actionList"
          />
        </div>
        <div class="form-item">
          <span>Bank</span>
          <el-form-item prop="bank_code">
            <v-select
              v-model="formData.bank_code"
              valueKey="bank_code"
              labelKey="bank_name"
              :list="bankList"/>
          </el-form-item>
        </div>
        <div class="form-item">
          <span>Cheque No.</span>
          <el-form-item prop="cheque_no">
            <v-input v-model="formData.cheque_no"/>
          </el-form-item>
        </div>
        <div class="form-item">
          <span>Date</span>
          <el-form-item prop="date">
            <v-date-picker
              v-model="formData.date"
            />
          </el-form-item>
        </div>
        <div class="form-item">
          <span>Amount</span>
          <el-form-item prop="amount">
            <v-input
              v-model.number="formData.amount"
              prepend="HK$"/>
          </el-form-item>
        </div>
        <div class="form-item">
          <span>Name of Account Holder</span>
          <el-form-item prop="holder">
            <v-input v-model="formData.holder"/>
          </el-form-item>
        </div> -->
        <div class="form-item">
          <span>Reference No.</span>
          <v-input v-model="formData.reference_no" />
        </div>
        <div class="form-item">
          <span>Proof</span>
          <file-container
            v-if="proof_file_id_pic_url"
            :fileData="{
              url: proof_file_id_pic_url
            }" />
          <v-upload
            :otherData="{
              idKey: 'proof_file_id',
              nameKey: 'proof_file_id_path',
              urlKey: 'proof_file_id_pic_url'
            }"
            @uploadSuccess="handlerUploadSuccess"
          />
        </div>
        <div class="form-item">
          <span>Remarks</span>
          <v-input
            v-model="formData.remark"
            type="textarea"
            :rows="4" />
        </div>
      </el-form>
      <div class="flex-sb">
        <div>
          <v-button @click="handlerCancel">Cancel</v-button>
        </div>
        <div>
          <v-button
            type="primary"
            @click="handlerValidForm">
            {{ editPayment? 'Save': 'Create' }}  
          </v-button>
        </div>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import { addSmePayment, editSmePayment} from '@/api/policy'
import MixinOptions from '@/mixins/options'
import { mapState } from 'vuex'
export default {
  name: 'AddPaymentRecord',
  mixins: [MixinOptions],
  props:{
    paymentForm:{
      type:Object,
      default:()=>({})
    },
    editPayment:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      dialog: false,
      createdForm:{
        // action:1,//1-New Policy 2-Endorsment
        // bank_code:null,
        // amount:null,
        // holder:null,
        proof_file_id:null,//非必须
        order_id:null,
        // date:null,
        // cheque_no:null,
        reference_no: '',
        remark: ''
      },
      proof_file_id:'',
      proof_file_id_path:'',
      proof_file_id_pic_url:'',
      formData:{
        // action:1,//1-New Policy 2-Endorsment
        // bank_code:null,
        // amount:null,
        // holder:null,
        proof_file_id:null,//非必须
        order_id:null,
        // date:null,
        // cheque_no:null
        reference_no: '',
        remark: ''
      },
      rules: {
        action: [
          { required: true, message: 'please select action', trigger: 'blur' },
        ],
        bank_code: [
          { required: true, message: 'please select bank', trigger: 'change' }
        ],
        amount: [
          {  required: true, message: 'please enter amount', trigger: 'change' }
        ],
        holder: [
          {  required: true, message: 'please enter Name of Account Holder', trigger: 'change' }
        ],
        date: [
          {  required: true, message: 'please select date', trigger: 'change' }
        ],
        cheque_no: [
          { required: true, message: 'please enter Cheque No.', trigger: 'change' }
        ]
      },
      actionList:[
        {
          name: 'New Policy',
          id: 1
        },
        {
          name: 'Endorsment',
          id: 2
        }
      ],

    }
  },
  computed:{
    ...mapState('common', ['bankList']),
    orderId(){
      return this.$route.query.id
    }
  },
  watch:{
    paymentForm:{
      immediate: true,
      deep: true,
      handler(val){
        if(val && JSON.stringify(val) != '{}'){
          const params = JSON.parse(JSON.stringify(val))
          const { 
            proof_file_id,
            proof_file_url,
            proof_file_name } = params
          this.formData = {
            ...this.formData,
            ...params,
          }
          this.proof_file_id = proof_file_id
          this.proof_file_id_path = proof_file_name
          this.proof_file_id_pic_url = proof_file_url
        }
      }
    },
    // editPayment:{
    //   immediate:true,
    //   handler(val){
    //     if(val){
    //       this.formData.action = this.paymentForm.type_language == 'New Policy'?1:2
    //       this.formData.date = this.paymentForm.success_at
    //       this.formData = Object.assign(this.formData,this.paymentForm)
    //       // this.   proof_file_id:'',
    //       //     proof_file_id_path:'',
    //       this. proof_file_id_pic_url=val.proof_file_url
    //     }else{
    //       // this.formData = JSON.parse(this.createdForm)
    //     }
    //   }
    // }
  },
  created() {
    // this.createdForm = JSON.stringify(this.formData)
    if(!this.bankList || this.bankList.length < 1) {
      this.getBankList()
    }
  },
  methods: {
    changeDialog() {
      this.dialog = !this.dialog
    },
    handlerCancel() {
      this.proof_file_id = ''
      this.proof_file_id_path = ''
      this.proof_file_id_pic_url = ''
      this.formData = JSON.parse(JSON.stringify(this.createdForm))
      this.$refs.form.resetFields()
      this.dialog = false
      this.$parent.paymentForm ={}
      this.$parent.editPayment =false
      setTimeout(() => {
        this.$refs['form'].clearValidate()
      }, 0)
    },
    handlerValidForm(){
      this.formData.order_id = Number(this.orderId)
      this.formData.trans_number = this.formData.number
      this.$refs.form.validate(valid=>{
        if(valid){
          if(this.editPayment)
            this.network().editSmePayment(this.formData)
          else 
            this.network().addSmePayment(this.formData)
          // if(data){
          //   this.$emit('updateData')
          // }
          // this.dialog =false
          // this.formData = JSON.parse(this.createdForm)
          // this.$refs.form.resetFields()
          // this.proof_file_id=''
          // this.proof_file_id_path=''
          // this.proof_file_id_pic_url=''
        }
      })
    },
    handlerInit() {
      this.dialog =false
      this.formData = JSON.parse(JSON.stringify(this.createdForm))
      this.$refs.form.resetFields()
      this.proof_file_id=''
      this.proof_file_id_path=''
      this.proof_file_id_pic_url=''
      setTimeout(() => {
        this.$refs['form'].clearValidate()
      }, 0)
    },
    //proof_file_id
    handlerUploadSuccess({ data, result, otherData }) {
      const { id, name, url } = data
      this.formData.proof_file_id = id
      this.proof_file_id_path = name
      this.proof_file_id_pic_url = url
    },
    handlerDeleteFile(otherData) {
      console.log('otherData',otherData)
    },
    network() {
      return {
        addSmePayment: async (params = {}) => {
          const { data } = await addSmePayment({
            ...params
          })

          this.$emit('updateData')
          this.handlerInit()
        },
        editSmePayment: async (params = {}) => {
          const { data } = await editSmePayment({
            ...params
          })
          this.$emit('updateData')
          this.handlerInit()
        }
      }
    }

  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
      padding: 15px;
      p {
        padding-bottom: 10px;
      }
      .dialog-footer {
        margin: 15px -15px -15px;
        padding: 15px;
        text-align: right;
        background: #F9FAFB;
      }
    }
</style>